import {IValidator} from "./IValidator";
import {IValidationRules} from "./IValidationRules";
import {RequiredValidator} from "./RequiredValidator";
import {ValidationResult} from "./ValidationResult";

export class Validator {
    private availableValidators: { [validatorName: string]: IValidator };

    constructor(private validationRules?: IValidationRules) {
        this.availableValidators = {
            required: new RequiredValidator()
        };
    }

    validate(form: JQuery): ValidationResult {
        let validationResult = new ValidationResult();

        if (!this.validationRules)
            return validationResult;

        let validationFields = Object.keys(this.validationRules);

        for (let fieldName of validationFields) {
            let fieldValidationRules = this.validationRules[fieldName];
            let validatorNames = Object.keys(fieldValidationRules).filter(validatorName => validatorName !== 'messages');

            for (let validatorName of validatorNames) {
                let validator = this.availableValidators[validatorName];
                let formField = form.find(`[name="${fieldName}"]`);

                if (!validator || validator.isValid(formField.val()))
                    continue;

                validationResult.push({
                    name: fieldName,
                    formField: formField,
                    validator: validator,
                    message: fieldValidationRules
                        && fieldValidationRules.messages
                        && fieldValidationRules.messages[validatorName]
                        || validator.defaultErrorMessage
                });
            }
        }

        return validationResult;
    }
}



// WEBPACK FOOTER //
// ./validation/Validator.ts